import { render, staticRenderFns } from "./ConceptOverview.vue?vue&type=template&id=f1216bf0&scoped=true&"
import script from "./ConceptOverview.vue?vue&type=script&lang=ts&"
export * from "./ConceptOverview.vue?vue&type=script&lang=ts&"
import style0 from "./ConceptOverview.vue?vue&type=style&index=0&id=f1216bf0&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1216bf0",
  null
  
)

export default component.exports